// We'll use this as our context key since an object is only equal to itself, and would not be equal to another empty object.
export const key = {};
